<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template #header>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-button
                  variant="secondary"
                  size="sm"
                  class="mr-3"
                  @click="goBack"
                >
                  <i class="fas fa-arrow-left"></i> Voltar
                </b-button>
                <strong>Perfis de Acesso - {{ company.fantasyName }}</strong>
              </div>
              <b-button
                variant="primary"
                size="sm"
                @click="onNewProfileClicked"
              >
                Novo Perfil de Acesso
              </b-button>
            </div>
          </template>

          <b-card-body>
            <div class="table-container">
              <b-table
                id="access-profiles-table"
                :items="retrieveData"
                :fields="headers"
                :busy="loading"
                borderless
                hover
                responsive
                show-empty
              >
                <template #cell(id)="cell">
                  {{ cell.item._id }}
                </template>
                <template #cell(name)="cell">
                  <span class="profile-name">{{ cell.item.name }}</span>
                </template>
                <template #cell(actions)="cell">
                  <b-button
                    size="sm"
                    variant="link"
                    class="action-icon"
                    title="Editar"
                    @click.stop="edit(cell.item)"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i>
                  </b-button>
                </template>

                <template #table-busy>
                  <div class="text-center py-5">
                    <b-spinner></b-spinner>
                    <span class="ml-2">Carregando...</span>
                  </div>
                </template>
                <template #empty>
                  <div class="text-muted text-center py-5">
                    <i class="fas fa-user-shield fa-2x"></i>
                    <p class="mt-3">Nenhum perfil de acesso encontrado</p>
                  </div>
                </template>
              </b-table>
            </div>
          </b-card-body>
        </b-card>
      </transition>
    </b-col>

    <!-- Sidebar -->
    <b-sidebar
      v-model="sidebarVisible"
      :title="sidebarTitle"
      right
      shadow
      width="50%"
      backdrop
      @hidden="onSidebarHidden"
    >
      <div class="px-3 py-2">
        <AccessProfileForm
          v-if="sidebarVisible"
          :company-id="id"
          :profile-id="selectedProfileId"
          @saved="onProfileSaved"
          @cancel="closeSidebar"
        />
      </div>
    </b-sidebar>
  </b-row>
</template>

<script>
import { getCompany, getCompanyRoles } from "@/api/company";
import AccessProfileForm from "./AccessProfileForm.vue";

export default {
  name: "AccessProfiles",
  components: {
    AccessProfileForm,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      company: {},
      loading: false,
      headers: [
        { key: "name", label: "Nome" },
        {
          key: "actions",
          label: "Ações",
          thStyle: { width: "160px !important" },
        },
      ],
      data: [],
      sidebarVisible: false,
      selectedProfileId: null,
    };
  },
  computed: {
    sidebarTitle() {
      return this.selectedProfileId
        ? "Editar Perfil de Acesso"
        : "Novo Perfil de Acesso";
    },
  },
  async created() {
    await this.reloadCompany();
  },
  methods: {
    async reloadCompany() {
      const response = await getCompany(this.id);
      this.company = response.data;
    },
    async retrieveData() {
      this.loading = true;
      try {
        const response = await getCompanyRoles(this.id);
        const data = response.data;
        this.data = data;
        return data;
      } catch (error) {
        console.error("Erro ao carregar perfis de acesso:", error);
        this.$bvToast.toast("Erro ao carregar perfis de acesso", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return [];
      } finally {
        this.loading = false;
      }
    },
    edit(item) {
      this.selectedProfileId = item._id;
      this.sidebarVisible = true;
    },
    onNewProfileClicked() {
      this.selectedProfileId = null;
      this.sidebarVisible = true;
    },
    closeSidebar() {
      this.sidebarVisible = false;
    },
    onSidebarHidden() {
      this.selectedProfileId = null;
    },
    async onProfileSaved() {
      this.closeSidebar();
      this.$bvToast.toast("Perfil de acesso salvo com sucesso!", {
        title: "Sucesso",
        variant: "success",
        solid: true,
      });
      // Recarrega a tabela
      this.$root.$emit("bv::refresh::table", "access-profiles-table");
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

::v-deep thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
  border: 0;
  white-space: nowrap;
}

::v-deep tbody tr {
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
}

::v-deep tbody tr:hover {
  background-color: #e9ecef !important;
}

::v-deep tbody tr:last-of-type {
  border-bottom: none;
}

::v-deep tbody td {
  border-top: none;
  vertical-align: middle;
  padding: 0.85rem 0.75rem;
}

.profile-name {
  color: #6c757d;
  font-weight: 500;
}

.action-icon {
  color: #6c757d;
  transition: color 0.2s;
}

::v-deep tbody tr:hover .action-icon {
  color: #007bff;
}
</style>
